import type { ParseKeys } from 'i18next';
import { z } from 'zod';

// A topic another screen opens the support page on, pre-filling the request.
export const SUPPORT_TOPICS = ['agency_upgrade'] as const;

export type SupportTopic = (typeof SUPPORT_TOPICS)[number];

export const supportSearchSchema = z.object({
  topic: z
    .enum(SUPPORT_TOPICS)
    .optional()
    .catch(() => void 0),
});

export const SUPPORT_TOPIC_DRAFT: Record<SupportTopic, ParseKeys<'support'>> = {
  agency_upgrade: 'support_draft.agency_upgrade',
};
